import Navbar from './Navbar';
import Footer from './Footer';
import FloatingContactButtons from '../common/FloatingContactButtons';

export default function PublicLayout({ children }) {
  return (
    <div className="flex min-h-screen w-full flex-col overflow-x-hidden">
      <Navbar />
      <main className="flex-1 w-full">{children}</main>
      <Footer />
      <FloatingContactButtons />
    </div>
  );
}
